import FormSection from '@/components/Forms/FormSection';
import { Box } from '@palmetto/palmetto-components';

import {
  InstallationPackagePhotoCategory,
  ProgramType,
  RequirementFlagSettingsType,
  WaterHeaterInstallPackageFileCategory,
} from 'types';

import { PhotosList } from '../Documents/PhotosList';

type InstallPhotosProps = {
  allowArchive?: boolean;
  showCheckboxes: boolean;
  checkboxCategories: WaterHeaterInstallPackageFileCategory[];
  isPackageEditable?: boolean;
};

export const InstallPhotos = ({
  allowArchive,
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: InstallPhotosProps) => {
  return (
    <FormSection
      title="All Installation Documentation"
      description={
        <Box gap="sm" fontSize="xs">
          <Box>
            Upload all documents and photos collected during the new system installation. These must include the
            Equipment Data Plate, Wide Installation View, Temperature &amp; Pressure (T&amp;P) Relief Valve, and
            Drain Pan &amp; Drain Line.
          </Box>
        </Box>
      }
    >
      <PhotosList
        title="Uploaded Install Documentation"
        baseCategory={'Install Photos'}
        allowArchive={allowArchive}
        category={InstallationPackagePhotoCategory.waterHeaterInstallationPhotos}
        flagType={RequirementFlagSettingsType.waterHeaterInstallationPhotos}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        programType={ProgramType.waterHeater}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
